﻿import { createApp } from 'vue';
import QuizModal from './quiz-modal/quiz-modal.vue';
import { fetchQuizSteps } from '@/api/services/quiz';

export class Quiz {
	private selector = '[data-url].js-quiz';
	private $buttons: HTMLElement[] = [];
	private container: HTMLElement | null = null;

	constructor() {
		this.init();
	}

	public init(): void {
		this.$buttons = Array.from(document.querySelectorAll(this.selector));
		this.$buttons.forEach((button) => {
			button.addEventListener('click', this.handleClick);
		});
	}

	public destroy(): void {
		this.$buttons.forEach((button) => {
			button.removeEventListener('click', this.handleClick);
		});
		this.$buttons = [];
	}

	private handleClick = async (event: Event): Promise<void> => {
		const button = event.currentTarget as HTMLElement;
		const url = button.dataset.url;

		if (!url) return;

		button.classList.add('button--loading');

		try {
			const modalData = await fetchQuizSteps(url);
			this.mountQuizModal(modalData, url);
		} finally {
			button.classList.remove('button--loading');
		}
	};

	private mountQuizModal(modalData: QuizData, url: string): void {
		this.container = document.createElement('div');
		document.body.appendChild(this.container);
		const app = createApp(QuizModal, {
			...modalData,
			url,
			onClose: () => {
				app.unmount();
				if (this.container && this.container.parentNode) {
					this.container.parentNode.removeChild(this.container);
				}
				this.container = null;
			},
		});

		app.use(window.app.pinia);
		app.mount(this.container);
	}
}
